import React, { Component } from 'react';

import { connect }          from 'react-redux';

import { withRouter }       from 'react-router-dom';

import Tabs                 from '../../../../components/tabs/Tabs';
import Tab                  from '../../../../components/tabs/Tab';

import Item                 from './Item';
import UnplannedItem        from './UnplannedItem';


class RouteInfo extends Component {

    renderRoutes() {

        const { list, route_list, branche_id } = this.props;

        if (!route_list.length) { return null; }
        
        const route_items = route_list.map((route_id) => {
            return (
                <li key={route_id}>
                    <Item
                        route_id={route_id}
                        url={'/groothandels/' + branche_id + '/routes/' + route_id}
                    />
                </li>
            );
        });

        return (
            <div className="item-list">
                <ul>
                    { route_items }
                </ul>
            </div>
        );
    }

    renderInternalRoutes() {

        const { internal_route_list, branche_id } = this.props;

        if (!internal_route_list.length) { return <p style={{ padding: 20, textAlign: 'center', fontStyle: 'italic' }}>Geen interne ritten</p>; }

        const route_items = internal_route_list.map((route_id) => {
            return (
                <li key={route_id}>
                    <Item
                        route_id={route_id}
                        url={'/groothandels/' + branche_id + '/routes/' + route_id}
                    />
                </li>
            );
        });

        return (
            <div className="item-list">
                <ul>
                    { route_items }
                </ul>
            </div>
        );
    }

    renderUnplannedRoutes() {

        const { unplanned_route_list, branche_id } = this.props;

        if (!unplanned_route_list.length) { return <p style={{ padding: 20, textAlign: 'center', fontStyle: 'italic' }}>Geen ongeplande ritten</p>; }

        const route_items = unplanned_route_list.map((route_id) => {
            return (
                <li key={route_id}>
                    <UnplannedItem
                        route_id={route_id}
                        url={'/groothandels/' + branche_id + '/routes/ongepland/' + route_id}
                    />
                </li>
            );
        });

        return (
            <div className="item-list">
                <ul>
                    { route_items }
                </ul>
            </div>
        );
    }

    render() {
        const { error, loading } = this.props;
        
        if (loading) { 
            return (
                <div className="card loading" style={ {flex:1} }>
                    <div>Bezig met laden...</div>
                </div>
            );
        }

        if (error) { return <div>Error! {error.message}</div>; }

        return (
            <div className="card" style={ {flex:1, overflow: 'hidden'} }>
                <Tabs>
                    <Tab label="Routes">
                        { this.renderRoutes() }
                    </Tab>
                    <Tab label="Intern">
                        { this.renderInternalRoutes() }
                    </Tab>
                    <Tab label="Ongepland">
                        { this.renderUnplannedRoutes() }
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state, props) {

    const { error, loading } = state.routes.all;

	return {
        error: error,
        loading: loading
	};
}

export default connect(mapStateToProps)(withRouter(RouteInfo));
